import { Pipe } from '@angular/core';
import type { PipeTransform } from '@angular/core';

/**
 * Returns string representation of Date in the format of dd/mm/YYYY
 */
@Pipe({
  name: 'tdWbAnalyticsDate'
})
export class AnalyticsDatePipe implements PipeTransform {
  transform(date: Date): string {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

}
